import React, { Component } from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import ChangePasswordHeader from './components/ChangePasswordHeader';
import ChangePasswordForm from './components/ChangePasswordForm';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5em;
`;

class ChangePassword extends Component {
  render() {
    return (
      <div>
        <ChangePasswordHeader history={this.props.history} />
        <Wrapper>
          <ChangePasswordForm history={this.props.history} />
        </Wrapper>
      </div>
    );
  }
}

export default withRouter(ChangePassword);



// WEBPACK FOOTER //
// ./src/components/screens/ChangePassword/ChangePassword.jsx